<template>
<div>
  <v-list class="pt-0">
    <v-list-item
      v-for="day in daysToShow"
      :key="day"
      :class="displayMode ? 'my-0' : 'my-2'">
      <v-row :class="isMobile ? 'pb-3' : 'py-3'">
        <v-col cols="12" md="4" class="py-0">
          {{day}}
        </v-col>
        <v-col :class="{'text-right': !isMobile}" class="pt-0" cols="12" md="8">
          <v-row>
            <v-col>
              <div v-for="range in hoursByDay(day)" :key="range.id">
                <span v-if="range">{{range.startTime}} - {{range.endTime}}</span>
              </div>
            </v-col>
            <v-col cols="auto" v-if="!displayMode">
              <EsButtonIcon
                icon="mdi-pencil"
                @click="openDialogForDay(day)" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-list-item>
  </v-list>
  <v-dialog v-if="serviceHoursDialog" v-model="serviceHoursDialog" width="650" scrollable>
    <EsServiceHoursDialog
      v-if="selectedDay"
      :daysOfWeek="daysOfWeek"
      :selectedDay="selectedDay"
      :existingRanges="existingRanges"
      :dark="dark"
      :isOpen="serviceHoursDialog"
      :isSaving="isSaving"
      @closeDialog="doneSaving()"
      @saveHours="save($event)" />
  </v-dialog>
</div>
</template>

<script>
import { EsButtonIcon } from "@86-repairs/design-system";
import EsServiceHoursDialog from "./EsServiceHoursDialog.vue";
import { uniqWith, isEqual } from 'lodash';

export default {
  name: 'EsServiceHours',
  props: {
    displayMode: {
      type: Boolean,
      default: false,
    },
    serviceHours: {
      type: Array,
      default: () => [],
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EsButtonIcon,
    EsServiceHoursDialog,
  },
  data: () => ({
    isSaving: false,
    daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    serviceHoursDialog: false,
    selectedDay: null,
    existingRanges: null,
  }),
  computed: {
    daysToShow() {
      const filteredDays = this.serviceHours.map((item) => item.dayName);
      const daysWithRanges = this.daysOfWeek.filter((day) => filteredDays.includes(day));
      return this.displayMode ? daysWithRanges : this.daysOfWeek;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    hoursByDay(day) {
      return this.serviceHours.filter((item) => item.dayName === day);
    },
    openDialogForDay(day) {
      this.selectedDay = day;
      this.existingRanges = this.serviceHours.filter((item) => item.dayName === day);
      this.serviceHoursDialog = true;
    },
    save(data) {
      this.isSaving = true;
      let editedRanges = this.serviceHours.filter((range) => !data.days.includes(range.dayName));
      data.days.forEach((day) => {
        data.ranges.forEach((range) => {
          editedRanges = editedRanges.concat({ ...range, dayName: day })
        })
      })

      this.$emit("saveServiceHours", {
        payload: editedRanges,
        done: () => this.doneSaving(),
      });
    },
    doneSaving() {
      this.isSaving = false;
      this.serviceHoursDialog = false;
      this.selectedDay = null;
      this.existingRanges = null;
    },
  }
};
</script>
